// extracted by mini-css-extract-plugin
module.exports = {"label":"RenderTextareaInput_label__3ul66","textArea":"RenderTextareaInput_textArea__1dyg2"};